import React from "react";
import RightSideModel from "src/components/popup/rightSide/RightSideModel";
import TTSColorForm from "../form/TTSColorForm/TTSColorForm";

const titlePopup = (isEdit) => {
  return isEdit ? "Edit Color" : "Create Color";
};

const TTSColorPopup = ({
  recordForEdit,
  openPopup,
  setOpenPopup,
  addOrEdit,
  errorsForm,
}) => {
  return (
    <RightSideModel
      openPopup={openPopup}
      setOpenPopup={setOpenPopup}
      title={titlePopup(Boolean(recordForEdit))}
    >
      <TTSColorForm
        recordForEdit={recordForEdit}
        addOrEdit={addOrEdit}
        errorsForm={errorsForm}
      />
    </RightSideModel>
  );
};

export default TTSColorPopup;
